import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import React from 'react';
import { cn } from '@core/utils/cn';

interface SortableItemProps {
    id: string;
    children: React.ReactNode;
}

export const SortableItem: React.FC<SortableItemProps> = ({ id, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        zIndex: isDragging ? 1000 : 'auto'
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={cn(
                'flex items-center gap-3 rounded-md border bg-card px-3 py-2 transition-all hover:bg-accent',
                isDragging ? 'border-primary shadow-md' : 'border-border'
            )}
        >
            <div
                className="flex cursor-grab items-center text-muted-foreground transition-colors hover:text-primary active:cursor-grabbing"
                {...attributes}
                {...listeners}
            >
                <GripVertical className="size-4" />
            </div>
            <div className="flex flex-1 flex-wrap items-end gap-3">
                {children}
            </div>
        </div>
    );
};
